import { TableDataLineUser } from '../../../components/organisms/Table/TableData/TableDataLineUser';
import { MY_ID } from '../../../helpers/user/authorization';
import { TableData } from '../../../components/organisms/Table/TableData';
import React from 'react';
import { ClasseDefWithUser } from '../../../types/classe/classe.def';
import pages from '../../../routes/pages';
import { GoToPage } from '../../../helpers/page/goToPage';

interface MaClasseViewProps {
  classe: ClasseDefWithUser;
  toPage: GoToPage;
}

export const MaClasseTab = ({ classe, toPage }: MaClasseViewProps) => {
  const toElevePage = toPage(pages.ELEVE_ACCOUNT_PAGE.path);
  const toSettingsPage = toPage(pages.MY_ACCOUNT.path);

  return (
    <TableData
      tabLabels={['Nom complet', 'Email', 'Pseudo', 'Mot de passe', '']}
    >
      {classe?.users
        ?.sort((a, b) => a.lastname.localeCompare(b.lastname))
        .map(user => (
          <TableDataLineUser
            key={user.id}
            user={user}
            toElevePage={
              user.id === MY_ID
                ? toSettingsPage
                : () => toElevePage({ id: user.id || MY_ID })
            }
          />
        ))}
    </TableData>
  );
};
